import { render } from "./PlotPartsBase.vue?vue&type=template&id=2ab248ec&scoped=true"
import script from "./PlotPartsBase.vue?vue&type=script&lang=js"
export * from "./PlotPartsBase.vue?vue&type=script&lang=js"

import "./PlotPartsBase.vue?vue&type=style&index=0&id=2ab248ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab248ec"]])

export default __exports__